import { sdk } from "@/config/medusa";
import { useUser } from "@/context/user";
import { Forms } from "@/types/form";
import { Actor } from "@/types/utils";
import storage from "@/utils/storage";
import { useEffect } from "react";
import { toast } from "sonner";

const useHydrateApp = () => {
  const { update, logout, setGlobalLoading } = useUser();
  const vid = storage.getItem("vid");

  const hydrateApp = async () => {
    setGlobalLoading(true);

    try {
      const user =
        await sdk.client.fetch<Forms["VendorUser"]>("/vendor/users/me");

      const { actor_type } = await sdk.client.fetch<Actor>("/actor/me");

      update(user, actor_type);
    } catch (error) {
      const status = (error as { status?: number })?.status;

      update(null, null);

      if (status === 401) {
        logout();
        window.location.reload();
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error("Failed to fetch user. Please try again.");
      }
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (!vid) return;
    hydrateApp();
  }, []);
};

export default useHydrateApp;
